import React from 'react';
import { VerisureQrCard } from './VerisureQrCard';
import { useNavigate } from 'react-router-dom';
import { EquipmentSize } from '../../types';

export interface VerisureQrCardModalProps {
  isOpen: boolean;
  onClose: () => void;
  value: string;
  assetId?: string;
  title?: string;
  subtitle?: string;
  size?: EquipmentSize;
  itemRoute?: string;
}

export const VerisureQrCardModal: React.FC<VerisureQrCardModalProps> = ({
  isOpen,
  onClose,
  value,
  assetId,
  title,
  subtitle,
  size = 'standard',
  itemRoute,
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-md flex items-center justify-center p-4 overflow-y-auto">
      <div className="relative max-w-2xl w-full my-8 flex flex-col items-center">
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-12 right-0 md:-right-4 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white w-10 h-10 rounded-full flex items-center justify-center text-2xl font-bold transition shadow-lg border border-slate-700 z-10"
          title="Close"
        >
          &times;
        </button>

        {/* Modal Header */}
        <div className="text-center mb-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-500/10 border border-orange-500/30 text-orange-400 text-xs font-bold rounded-full mb-1">
            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse"></span>
            Official Security Identity Tag
          </div>
          <h2 className="text-xl font-black text-white">Verisure QR Identity Card</h2>
          <p className="text-slate-400 text-xs mt-0.5">
            Equipment-scaled tamper-evident verification tag for field inspection & repair tracking
          </p>
        </div>

        {/* Card Component */}
        <div className="bg-slate-900/40 p-4 rounded-3xl border border-slate-800 backdrop-blur w-full flex justify-center">
          <VerisureQrCard
            value={value}
            assetId={assetId}
            title={title}
            subtitle={subtitle}
            size={size}
            showSizeSelector={true}
            showActions={true}
          />
        </div>

        {/* Optional View Profile Link */}
        {itemRoute && (
          <div className="mt-4 flex gap-3 w-full max-w-[430px]">
            <button
              type="button"
              onClick={() => {
                onClose();
                navigate(itemRoute);
              }}
              className="flex-1 bg-gradient-to-r from-red-500/15 via-orange-500/20 to-amber-500/15 hover:bg-orange-500/30 border border-orange-500/40 text-orange-400 text-xs font-bold py-2.5 rounded-xl transition flex items-center justify-center gap-2"
            >
              View Public Asset Profile &rarr;
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

